// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3FXBu","row":"Node_row__3mcjw","label":"Node_label__3mRu3","footer":"Node_footer__10cN7"};